import { useQuery } from '@tanstack/react-query';

import type { GetDocumentMetadataResponse } from 'wg-api-sdk';

import type { QueryOptions } from '@/types/react-query';

import documentQueryOptions from './../documentQueryOptions';

export default function useDocuments(
  id: string,
  options?: QueryOptions<GetDocumentMetadataResponse>,
) {
  return useQuery({
    ...documentQueryOptions(id),
    ...options,
  });
}
